import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.patients');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-patients',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.patients/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PagePatientsComponent implements OnInit {
    public patients: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 20;
    public searchText: string = '';
    public statusFilter: string = '';

    // 상세 모달
    public showDetail: boolean = false;
    public selectedPatient: any = null;
    public detailTab: string = 'info';
    public editMode: boolean = false;
    public editBackup: any = null;

    // sub-form toggles
    public showAddCondition: boolean = false;
    public showAddAllergy: boolean = false;
    public showAddMedication: boolean = false;
    public newConditionForm: any = { condition_name: '', severity: '' };
    public newAllergyForm: any = { allergen: '', reaction: '' };
    public newMedicationForm: any = { medication_name: '', dosage: '' };

    public get detailPatient() { return this.selectedPatient; }
    public set detailPatient(val: any) { this.selectedPatient = val; }
    public get visitHistoryRows() { return this.visitHistory; }
    public Math = Math;

    // 환자 등록 모달
    public showCreate: boolean = false;
    public createForm: any = {};

    // 병력/알레르기/복용약 폼
    public conditionForm: any = {};
    public allergyForm: any = {};
    public medicationForm: any = {};

    // 진료 이력
    public visitHistory: any[] = [];
    public visitTotal: number = 0;
    public visitPage: number = 1;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
        await this.service.render();
    }

    public async load(page: number = 1) {
        this.page = page;
        const { code, data } = await wiz.call('search', {
            text: this.searchText, page: this.page, dump: this.dump, status: this.statusFilter
        });
        if (code === 200) {
            this.patients = data.rows || [];
            this.total = data.total || 0;
        }
        await this.service.render();
    }

    public get totalPages() { return Math.ceil(this.total / this.dump); }
    public get pages() {
        const arr = [];
        const start = Math.max(1, this.page - 2);
        const end = Math.min(this.totalPages, start + 4);
        for (let i = start; i <= end; i++) arr.push(i);
        return arr;
    }

    public visibleActiveCount() {
        return this.patients.filter((patient: any) => (patient.status || 'active') === 'active').length;
    }

    public visibleInactiveCount() {
        return this.patients.filter((patient: any) => patient.status === 'inactive').length;
    }

    public visibleMissingContactCount() {
        return this.patients.filter((patient: any) => !patient.phone && !patient.email).length;
    }

    public getPatientStatusLabel(patient: any) {
        return (patient?.status || 'active') === 'inactive' ? '비활성' : '활성';
    }

    public getPatientStatusBadge(patient: any) {
        return (patient?.status || 'active') === 'inactive'
            ? 'bg-slate-100 text-slate-500'
            : 'bg-emerald-50 text-emerald-700';
    }

    public getPatientStatusClass(patient: any) {
        return (patient?.status || 'active') === 'inactive'
            ? 'bg-slate-200 text-slate-600'
            : 'bg-emerald-100 text-emerald-700';
    }

    public getPatientInitial(patient: any) {
        const name = (patient?.name || '').trim();
        if (!name) return '?';
        return name.slice(0, Math.min(2, name.length));
    }

    public selectedRiskCount() {
        if (!this.selectedPatient) return 0;
        return (this.selectedPatient.conditions || []).length + (this.selectedPatient.allergies || []).length + (this.selectedPatient.medications || []).length;
    }

    public async openDetail(patient: any) {
        const { code, data } = await wiz.call('get', { id: patient.id });
        if (code === 200) {
            this.selectedPatient = data;
            this.showDetail = true;
            this.detailTab = 'info';
            this.resetSubForms();
            await this.service.render();
        }
    }

    public closeDetail() {
        this.showDetail = false;
        this.selectedPatient = null;
        this.editMode = false;
        this.service.render();
    }

    public startEdit() {
        this.editBackup = JSON.parse(JSON.stringify(this.selectedPatient));
        this.editMode = true;
        this.service.render();
    }

    public async saveEdit() {
        if (!this.selectedPatient) return;
        const { code } = await wiz.call('update', this.selectedPatient);
        if (code === 200) {
            this.editMode = false;
            await this.load();
            await this.service.render();
        }
    }

    public cancelEdit() {
        if (this.editBackup) {
            this.selectedPatient = this.editBackup;
        }
        this.editMode = false;
        this.service.render();
    }

    public async switchTab(tab: string) {
        this.detailTab = tab;
        if (tab === 'visits' && this.selectedPatient) {
            await this.loadVisitHistory(1);
        }
        await this.service.render();
    }

    public async loadVisitHistory(page: number = 1) {
        this.visitPage = page;
        const { code, data } = await wiz.call('visit_history', {
            patient_id: this.selectedPatient.id, page, dump: 10
        });
        if (code === 200) {
            this.visitHistory = data.rows || [];
            this.visitTotal = data.total || 0;
        }
        await this.service.render();
    }

    public openCreate() {
        this.showCreate = true;
        this.createForm = { name: '', phone: '', gender: '', birth_date: '', address: '', insurance_type: 'NHI', memo: '' };
        this.service.render();
    }

    public closeCreate() { this.showCreate = false; this.service.render(); }

    public async submitCreate() {
        if (!this.createForm.name) {
            await this.service.modal.show({ title: '알림', message: '환자명을 입력해주세요', action: '확인' });
            return;
        }
        if (!this.createForm.phone && !this.createForm.birth_date) {
            await this.service.modal.show({ title: '알림', message: '연락처 또는 생년월일 중 하나를 입력해주세요', action: '확인' });
            return;
        }
        const { code, data } = await wiz.call('create', this.createForm);
        if (code === 200) {
            this.closeCreate();
            await this.load(1);
        } else {
            await this.service.modal.show({ title: '오류', message: data.message || '등록 실패', action: '확인' });
        }
    }

    public async savePatient() {
        if (!this.selectedPatient) return;
        const { code } = await wiz.call('update', this.selectedPatient);
        if (code === 200) {
            await this.service.modal.show({ title: '완료', message: '환자 정보가 저장되었습니다', action: '확인' });
            await this.load(this.page);
        }
    }

    public async deletePatient() {
        const res = await this.service.modal.show({
            title: '환자 삭제',
            message: `${this.selectedPatient.name} 환자를 삭제하시겠습니까? (비활성화 처리)`,
            action: '삭제', actionBtn: 'bg-red-500', cancel: '취소'
        });
        if (res) {
            await wiz.call('delete', { id: this.selectedPatient.id });
            this.closeDetail();
            await this.load(this.page);
        }
    }

    private resetSubForms() {
        this.conditionForm = { patient_id: this.selectedPatient?.id, condition_name: '', severity: 'mild', is_current: 'true' };
        this.allergyForm = { patient_id: this.selectedPatient?.id, allergy_type: 'drug', allergen: '', reaction: '', severity: 'mild' };
        this.medicationForm = { patient_id: this.selectedPatient?.id, medication_name: '', dosage: '', frequency: '', is_current: 'true' };
    }

    public async addCondition() {
        if (!this.conditionForm.condition_name) return;
        this.conditionForm.patient_id = this.selectedPatient.id;
        await wiz.call('add_condition', this.conditionForm);
        await this.refreshPatient();
    }

    public async removeCondition(id: string) {
        await wiz.call('remove_condition', { id });
        await this.refreshPatient();
    }

    public async addAllergy() {
        if (!this.allergyForm.allergen) return;
        this.allergyForm.patient_id = this.selectedPatient.id;
        await wiz.call('add_allergy', this.allergyForm);
        await this.refreshPatient();
    }

    public async removeAllergy(id: string) {
        await wiz.call('remove_allergy', { id });
        await this.refreshPatient();
    }

    public async addMedication() {
        if (!this.medicationForm.medication_name) return;
        this.medicationForm.patient_id = this.selectedPatient.id;
        await wiz.call('add_medication', this.medicationForm);
        await this.refreshPatient();
    }

    public async removeMedication(id: string) {
        await wiz.call('remove_medication', { id });
        await this.refreshPatient();
    }

    private async refreshPatient() {
        if (!this.selectedPatient) return;
        const { code, data } = await wiz.call('get', { id: this.selectedPatient.id });
        if (code === 200) {
            this.selectedPatient = data;
            this.resetSubForms();
        }
        await this.service.render();
    }

    public hasActiveVisit(patient: any) {
        return !!patient?.active_visit?.id;
    }

    public canOpenVisit(visit: any) {
        return !!visit?.id;
    }

    public openVisitChart(visit: any) {
        if (!visit?.id) return;
        this.service.href(`/chart/${visit.id}`);
    }

    public getVisitStatusLabel(status: string) {
        const map: any = {
            waiting: '접수대기',
            intake: '예진중',
            ready: '진료대기',
            in_progress: '진료중',
            charting: '기록정리',
            prescribing: '처방·후속',
            completed: '완료',
            cancelled: '취소',
        };
        return map[status] || status || '방문 없음';
    }

    public getVisitTypeLabel(type: string) {
        const map: any = {
            outpatient: '초진',
            initial: '초진',
            revisit: '재진',
            followup: '재진',
            emergency: '응급',
        };
        return map[type] || '일반';
    }

    public getVisitFlowTitle(patient: any) {
        if (patient?.active_visit) {
            return `${this.getVisitStatusLabel(patient.active_visit.status)} · ${patient.active_visit.visit_date || '오늘'}`;
        }
        if (patient?.latest_visit) {
            return `${patient.latest_visit.visit_date || '-'} 방문`;
        }
        return '방문 이력 없음';
    }

    public getVisitFlowDescription(patient: any) {
        if (patient?.active_visit) {
            return `${this.getVisitTypeLabel(patient.active_visit.visit_type)} · 접수번호 ${patient.active_visit.reception_number || '-'}`;
        }
        if (patient?.latest_visit) {
            return `${this.getVisitTypeLabel(patient.latest_visit.visit_type)} · ${this.getVisitStatusLabel(patient.latest_visit.status)}`;
        }
        return '운영 보드에서 새 방문을 생성할 수 있습니다.';
    }

    public getGenderLabel(g: string) { return g === 'M' ? '남' : g === 'F' ? '여' : '-'; }
    public getAge(birthDate: string) {
        if (!birthDate) return '-';
        const bd = new Date(birthDate);
        if (Number.isNaN(bd.getTime())) return '-';
        const diff = Date.now() - bd.getTime();
        return Math.floor(diff / (365.25 * 24 * 60 * 60 * 1000)) + '세';
    }
    public getInsuranceLabel(t: string) {
        const map: any = { 'NHI': '건강보험', 'MED': '의료급여', 'IND': '산재보험', 'CAR': '자동차보험', 'SELF': '비급여', 'OTHER': '기타' };
        return map[t] || t;
    }
}

export default PagePatientsComponent;